import { useState, useCallback, useEffect, useMemo } from "react";
import { useWindowSize } from "@perxis-auto/shared";
function useAvailableHeight(ref) {
  const windowSize = useWindowSize();
  const { height: windowHeight } = windowSize || {};
  const [height, setHeight] = useState(windowHeight);
  const calcAvailableHeight = useCallback(() => {
    if (ref.current) {
      setHeight(windowHeight - Math.max(ref.current.getBoundingClientRect().top, 0));
    }
  }, [windowHeight, ref]);
  useEffect(() => {
    const debouncedListener = calcAvailableHeight;
    calcAvailableHeight();
    window.addEventListener("scroll", debouncedListener);
    return () => window.removeEventListener("scroll", debouncedListener);
  }, [calcAvailableHeight, windowHeight]);
  return useMemo(
    () => ({
      height
    }),
    [height]
  );
}
export {
  useAvailableHeight
};
